import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { Dropdown, DropdownButton } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import InvisibleInput from '../../Pages/PageElements/InvisibleInput';
import ExerciseReps from '../../Links/ExerciseReps';

const MapExercise = (props) => {
    const {
        index, exercise, handleChangeExerciseName, holderFunction, getTitle, handleSwitchType, handleChangeExerciseReps,
        handleChangeDistance, handleChangeExerciseTime, handleChangeCVMode, removeExercise
    } = props;

    // Determine current CV mode: 'km' if distance is set, 'mins' if time is set, or null
    const getCVMode = () => {
        // Check if distance exists (even if empty string) and time is null - means km mode is selected
        if (exercise.distance !== null && exercise.distance !== undefined && exercise.time === null) {
            return 'km';
        }
        // Check if time exists (even if empty string) and distance is null - means mins mode is selected
        if (exercise.time !== null && exercise.time !== undefined && exercise.distance === null) {
            return 'mins';
        }
        return null;
    };

    const handleModeChange = (eventKey) => {
        // eventKey comes from the Dropdown.Item eventKey prop
        if (eventKey === 'km' || eventKey === 'mins') {
            handleChangeCVMode(index, eventKey);
        }
    };

    return (
        <Row style={{ marginBottom: '10px' }}>
            <Col xs={5} style={{ paddingLeft: 0 }}>
                {exercise.type === 'Time' ?
                    <InvisibleInput value={exercise.name} onInput={handleChangeExerciseName}
                        onBlur={holderFunction} name={index} type={"text"} disabled={true} />
                    :
                    <InvisibleInput value={exercise.name} onInput={handleChangeExerciseName}
                        onBlur={holderFunction} name={index} type={"text"} />
                }
            </Col>
            <Col xs={2} style={{ paddingLeft: 0, paddingRight: 0 }}>
                <DropdownButton
                    id="custom-dropdown"
                    title={getTitle(exercise.type)}
                    onSelect={handleSwitchType}
                    variant="info"
                >
                    <Dropdown.Item eventKey={"CV-" + index}>Cardio</Dropdown.Item>
                    <Dropdown.Item eventKey={"Weights-" + index}>Lifts</Dropdown.Item>
                    <Dropdown.Item eventKey={"Time-" + index}>Time</Dropdown.Item>
                </DropdownButton>
            </Col>
            {exercise.type === 'Weights' ?
                <>
                    <Col xs={2} />
                    <Col xs={2}>
                        <ExerciseReps exercise={exercise} index={index} handleChangeExerciseReps={handleChangeExerciseReps} />
                    </Col>
                </>

                : exercise.type === 'CV' ?
                    <>
                        <Col xs={3}>
                            <Row>
                                <Col xs={4} style={{ paddingRight: '5px' }}>
                                    <DropdownButton
                                        id={`cv-mode-${index}`}
                                        title={getCVMode() === 'km' ? 'km' : getCVMode() === 'mins' ? 'Mins' : 'Select'}
                                        onSelect={handleModeChange}
                                        variant="info"
                                        size="sm"
                                    >
                                        <Dropdown.Item eventKey="km">km</Dropdown.Item>
                                        <Dropdown.Item eventKey="mins">Mins</Dropdown.Item>
                                    </DropdownButton>
                                </Col>
                                <Col xs={8} style={{ paddingLeft: '5px' }}>
                                    {getCVMode() === 'km' ? (
                                        <Form.Control
                                            value={exercise.distance || ''}
                                            name={exercise.name.toLowerCase().replace(/\s+/g, '_').replace(/[^\w_]+/g, '') + '~' + index}
                                            type="text"
                                            placeholder="km"
                                            onInput={handleChangeDistance}
                                            size="sm"
                                        />
                                    ) : getCVMode() === 'mins' ? (
                                        <Form.Control
                                            value={exercise.time || ''}
                                            name={exercise.name.toLowerCase().replace(/\s+/g, '_').replace(/[^\w_]+/g, '') + '~' + index}
                                            type="text"
                                            placeholder="Mins"
                                            onInput={handleChangeExerciseTime}
                                            size="sm"
                                        />
                                    ) : (
                                        <Form.Control
                                            type="text"
                                            placeholder="Select mode first"
                                            disabled
                                            size="sm"
                                        />
                                    )}
                                </Col>
                            </Row>
                        </Col>
                    </>
                    :
                    <>
                        <Col xs={3} />
                    </>
            }
            <Col xs={1} style={{ textAlign: 'center' }}>
                <FontAwesomeIcon style={{ cursor: 'pointer' }} icon={faTrash} onClick={() => {
                    removeExercise(index);
                }} />
            </Col>
        </Row>
    )
}

export default MapExercise